module.exports = __webpack_public_path__ + "fonts/MyriadPro-BoldCond.340f97b.ttf";